var exports = {
  "r": "MonaDivider__7bucna",
};

module.exports = exports;
